export const PaymentStatus = {
  BELUM_LENGKAP: "BELUM LENGKAP",
  BELUM_REALISASI: "BELUM REALISASI",
  REALISASI: "REALISASI",
};
